import * as React from 'react';

import { DayBudgetValue, WalletDayBudgetValue } from '../../typings/budget';
import { DailyBudgetLimit } from '../../typings/constants';
import { CurrencyCode } from '../../typings/graphql-grid';
import { CampaignDayBudgetInfo } from '../CampaignDayBudgetInfo/CampaignDayBudgetInfo';
import { ControlledDayBudgetEditPopup } from '../ControlledDayBudgetEditPopup/ControlledDayBudgetEditPopup';

export interface GridCampaignDayBudgetCellProps {
    walletBudget?: WalletDayBudgetValue;
    value?: DayBudgetValue;
    editable: boolean;
    currency: CurrencyCode;
    agencyId: string | null;
    campaignId: string;
    isSaving: boolean;
    saveDayBudget: (value: DayBudgetValue) => void;
    dailyBudgetLimit: DailyBudgetLimit;
    columnName: string;
    login: string;
    error?: string;
    isGridScrolling: boolean;
    isCompactViewEnabled: boolean;
}

interface GridCampaignDayBudgetCellState {
    isDayBudgetEditPopupOpened: boolean;
}

export class GridCampaignDayBudgetCell extends React.Component<
    GridCampaignDayBudgetCellProps,
    GridCampaignDayBudgetCellState
> {
    static getDerivedStateFromProps(
        nextProps: GridCampaignDayBudgetCellProps,
        prevState: GridCampaignDayBudgetCellState
    ) {
        if (nextProps.isGridScrolling) {
            return {
                ...prevState,
                isDayBudgetEditPopupOpened: false
            };
        }

        return null;
    }

    componentDidUpdate(prevProps: GridCampaignDayBudgetCellProps) {
        if (
            (prevProps.isSaving !== this.props.isSaving ||
                prevProps.error !== this.props.error) &&
            !this.props.isSaving &&
            !this.props.error
        ) {
            this.setState({
                isDayBudgetEditPopupOpened: false
            });
        }
    }

    constructor(props: GridCampaignDayBudgetCellProps) {
        super(props);

        this.state = {
            isDayBudgetEditPopupOpened: false
        };
    }

    shouldComponentUpdate(
        nextProps: GridCampaignDayBudgetCellProps,
        nextState: GridCampaignDayBudgetCellState
    ) {
        return (
            nextProps.editable !== this.props.editable ||
            nextProps.agencyId !== this.props.agencyId ||
            nextProps.campaignId !== this.props.campaignId ||
            nextProps.isSaving !== this.props.isSaving ||
            nextProps.walletBudget !== this.props.walletBudget ||
            nextProps.value !== this.props.value ||
            nextProps.dailyBudgetLimit !== this.props.dailyBudgetLimit ||
            nextProps.login !== this.props.login ||
            nextProps.columnName !== this.props.columnName ||
            nextProps.error !== this.props.error ||
            nextProps.isGridScrolling !== this.props.isGridScrolling ||
            nextState.isDayBudgetEditPopupOpened !==
                this.state.isDayBudgetEditPopupOpened
        );
    }

    render() {
        const {
            value,
            campaignId,
            currency,
            saveDayBudget,
            dailyBudgetLimit,
            isSaving,
            walletBudget,
            error,
            editable,
            isCompactViewEnabled
        } = this.props;
        const { isDayBudgetEditPopupOpened } = this.state;

        if (!editable) {
            return (
                <CampaignDayBudgetInfo
                    value={value}
                    isCompactViewEnabled={isCompactViewEnabled}
                />
            );
        }

        return (
            <ControlledDayBudgetEditPopup
                error={error}
                walletBudget={walletBudget}
                value={value}
                campaignId={campaignId}
                isSaving={isSaving}
                currency={currency}
                saveDayBudget={saveDayBudget}
                onSaveSuccess={this.onCancelEditing}
                onCancel={this.onCancelEditing}
                isPopupOpened={isDayBudgetEditPopupOpened}
                dailyBudgetLimit={dailyBudgetLimit}
            >
                <CampaignDayBudgetInfo
                    editable={true}
                    onClick={this.openDayBudgetEditPopup}
                    isActive={isDayBudgetEditPopupOpened}
                    value={value}
                    isCompactViewEnabled={isCompactViewEnabled}
                />
            </ControlledDayBudgetEditPopup>
        );
    }

    private openDayBudgetEditPopup = () => {
        this.setState({ isDayBudgetEditPopupOpened: true });
    };

    private onCancelEditing = () => {
        this.setState({
            isDayBudgetEditPopupOpened: false
        });
    };
}
